<template>
  <header class="flex justify-between items-center w-full bg-white py-4 px-4 sm:px-6 md:px-24 lg:px-32 fixed top-0 left-0 z-50 h-24 shadow-md">
    <!-- Logo -->
    <div class="flex items-center flex-shrink-0">
      <a @click="scrollToTop" class="cursor-pointer">
        <img
          src="@/assets/images/logonormalescura.png"
          alt="Logo"
          class="h-28 sm:h-28 md:h-32 lg:h-40 pl-10 md:pl-20"
        />
      </a>
    </div>

    <!-- Ícone do Menu de Hambúrguer -->
    <button
      class="md:hidden text-slate-900 focus:outline-none"
      @click="toggleMenu"
    >
      <img src="@/assets/images/menu.svg" alt="Menu de Hamburguer" class="h-10 pr-8">
    </button>

    <!-- Menu de Navegação -->
    <nav
      :class="`${
        isMenuOpen ? 'flex' : 'hidden'
      } flex-col md:flex-row md:flex items-center gap-5 md:gap-10 absolute md:static bg-white top-20 left-0 w-full md:w-auto shadow-md md:shadow-none z-40 px-6 md:px-0`"
    >
      <a
        @click="handleLinkClick('about')"
        class="text-slate-900 text-lg hover:bg-purple-900 hover:text-white font-bold py-2 px-4 rounded-full transition duration-300 cursor-pointer"
      >
        Sobre Nós
      </a>
      <a
        @click="handleLinkClick('services')"
        class="text-slate-900 text-lg hover:bg-purple-900 hover:text-white font-bold py-2 px-4 rounded-full transition duration-300 cursor-pointer"
      >
        Serviços
      </a>
      <a
          @click="handleLinkClick('atendimento')"
          class="text-slate-900 text-lg hover:bg-purple-900 hover:text-white font-bold py-2 px-4 rounded-full transition duration-300 cursor-pointer"
        >
          Atendimento
      </a>
      <a
        @click="handleLinkClick('testimonials')"
        class="text-slate-900 text-lg hover:bg-purple-900 hover:text-white font-bold py-2 px-4 rounded-full transition duration-300 cursor-pointer"
      >
        Depoimentos
      </a>
      <a
        @click="handleLinkClick('footer')"
        :class="`text-slate-900 text-lg hover:bg-purple-900 hover:text-white font-bold py-2 px-4 rounded-full transition duration-300 cursor-pointer 
        ${isMenuOpen ? 'mb-6 md:mt-0' : ''}`"
      >
        Fale Conosco
      </a>
    </nav>
  </header>

  <!-- Espaço para não sobrepor o conteúdo -->
  <div class="pt-24"></div> 
</template>

<script setup>
import { ref } from "vue";

// Estado do menu
const isMenuOpen = ref(false);

// Alternar o menu
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

// Fechar menu após clicar em um link
const handleLinkClick = (sectionId) => {
  isMenuOpen.value = false;
  scrollToSection(sectionId);
};

// Rolar até o topo da página
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// Rolar até uma seção específica
const scrollToSection = (sectionId) => {
  const sectionElement = document.getElementById(sectionId);
  if (sectionElement) {
    sectionElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
</script>

<style scoped>
header {
  backdrop-filter: blur(10px); /* Transparência com desfoque */
}
</style>
